var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSellButtonArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2734 0.278417L18.0866 6.32784C18.5047 6.69906 18.5047 7.30094 18.0866 7.67216L11.2734 13.7216C10.8554 14.0928 10.1775 14.0928 9.75941 13.7216C9.34131 13.3504 9.34131 12.7485 9.75941 12.3773L14.745 7.95058L0.200195 7.95058L0.200195 6.04942L14.745 6.04942L9.75941 1.62273C9.34131 1.25151 9.34131 0.64964 9.75941 0.278417C10.1775 -0.0928057 10.8554 -0.0928057 11.2734 0.278417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellButtonArrow);
export default __webpack_public_path__ + "static/media/sell-button-arrow.e67f28a54d1edbd0051079b58522c4a6.svg";
export { ForwardRef as ReactComponent };